<template>
  <div v-if="loaded">
    <div class="hero" v-if="$route.params.id == 4 || !$route.params.id">
        <img src="../assets/images/new/hero-bg.jpg" alt="welcome our page">

        <div class="hero__content">
            <div class="content-left">
                <h1 class="hero__title" :class="[currentLanguage == 'AR' ? 'rtlText': '']">{{ $t("newhome.hero.title") }}</h1>
                <a :href="landingPage">
                  <button class="hero__cta" :class="[currentLanguage == 'AR' ? 'rtlText': '']" v-if="!isLoggedIn">{{ $t("newhome.hero.button") }}</button>
                </a>
            </div>
            <div class="content-right">
                <img src="../assets/images/new/hero-graphics.png" alt="welcome our page">
            </div>
        </div>
    </div>
    <div class="info-boxes" v-if="$route.params.id == 4 || !$route.params.id">
        <div class="section__inner">
            <ul>
                    <li>
                        <div class="list-image">
                            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M10 0.3125C4.65626 0.3125 0.3125 4.65626 0.3125 10C0.3125 15.3437 4.65626 19.6875 10 19.6875C15.3437 19.6875 19.6875 15.3437 19.6875 10C19.6875 4.65626 15.3437 0.3125 10 0.3125ZM6.31874 5.79373C7.06249 5.79373 7.66251 6.39374 7.66251 7.13749C7.66251 7.87498 7.06249 8.48125 6.31874 8.48125C5.57499 8.48125 4.97502 7.87498 4.97502 7.13749C4.97501 6.39374 5.57499 5.79373 6.31874 5.79373ZM5.80624 12.075C6.16875 11.7125 6.76251 11.7125 7.13124 12.075C7.90001 12.8437 8.91877 13.2687 10 13.2687C11.0812 13.2687 12.1 12.8437 12.8688 12.075C13.2375 11.7125 13.8313 11.7125 14.1938 12.075C14.5625 12.4437 14.5625 13.0375 14.1938 13.4C13.0687 14.525 11.5813 15.1437 10 15.1437C8.41873 15.1437 6.93127 14.525 5.80624 13.4C5.43751 13.0375 5.43751 12.4437 5.80624 12.075ZM13.6813 8.48126C12.9375 8.48126 12.3375 7.87499 12.3375 7.13749C12.3375 6.39374 12.9375 5.79373 13.6813 5.79373C14.425 5.79373 15.025 6.39374 15.025 7.13749C15.025 7.87499 14.425 8.48126 13.6813 8.48126Z" fill="white"/>
                            </svg>
                        </div>
                        <div class="list-data">
                            <h2 :class="[currentLanguage == 'AR' ? 'rtlText': '']">{{ $t("newhome.banner1.title1") }}</h2>
                        </div>
                    </li>
                     <li>
                        <div class="list-image">
                            <svg width="24" height="16" viewBox="0 0 24 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M0.285645 10.2857H16.2856V12H1.4285C0.797073 12 0.285645 11.4886 0.285645 10.8571V10.2857ZM20.2856 3.42857V1.14286C20.2856 0.511429 19.7742 0 19.1428 0H1.4285C0.797073 0 0.285645 0.511429 0.285645 1.14286V9.14286H16.2856V5.14286C16.2856 4.19714 17.0542 3.42857 17.9999 3.42857H20.2856ZM12.8571 14.8571H11.5885L11.2456 13.1429H9.32564L8.98279 14.8571H7.71422C7.39993 14.8571 7.14279 15.1143 7.14279 15.4286C7.14279 15.7429 7.39993 16 7.71422 16H12.8571C13.1714 16 13.4285 15.7429 13.4285 15.4286C13.4285 15.1143 13.1714 14.8571 12.8571 14.8571ZM17.4285 14.2857C17.4285 14.6 17.6856 14.8571 17.9999 14.8571H23.1428C23.4571 14.8571 23.7142 14.6 23.7142 14.2857V13.4286H17.4285V14.2857ZM23.1428 4.57143H17.9999C17.6856 4.57143 17.4285 4.82857 17.4285 5.14286V6H23.7142V5.14286C23.7142 4.82857 23.4571 4.57143 23.1428 4.57143ZM17.4285 12.2857H23.7142V7.14286H17.4285V12.2857Z" fill="white"/>
                            </svg>
                        </div>
                        <div class="list-data">
                            <h2 :class="[currentLanguage == 'AR' ? 'rtlText': '']">{{ $t("newhome.banner1.title2") }}</h2>
                            <p></p>
                        </div>
                    </li>
                    <li>
                        <div class="list-image">
                            <svg width="14" height="18" viewBox="0 0 14 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M0.456543 1.94287C0.456543 1.15171 1.33179 0.673864 1.9973 1.10169L12.9752 8.15892C13.5875 8.55255 13.5875 9.44764 12.9752 9.84127L1.9973 16.8985C1.33179 17.3263 0.456543 16.8485 0.456543 16.0573V1.94287Z" fill="white"/>
                            </svg>
                        </div>
                         <div class="list-data">
                            <h2>{{ $t("newhome.banner1.title3") }}</h2>
                        </div>
                    </li>
                    <li>
                        <div class="list-image">
                            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M10 0C8.02219 0 6.08879 0.58649 4.4443 1.6853C2.79981 2.78412 1.51809 4.3459 0.761209 6.17317C0.00433284 8.00043 -0.193701 10.0111 0.192152 11.9509C0.578004 13.8907 1.53041 15.6725 2.92894 17.0711C4.32746 18.4696 6.10929 19.422 8.0491 19.8079C9.98891 20.1937 11.9996 19.9957 13.8268 19.2388C15.6541 18.4819 17.2159 17.2002 18.3147 15.5557C19.4135 13.9112 20 11.9778 20 10C20 8.68678 19.7413 7.38642 19.2388 6.17317C18.7363 4.95991 17.9997 3.85752 17.0711 2.92893C16.1425 2.00035 15.0401 1.26375 13.8268 0.761205C12.6136 0.258658 11.3132 0 10 0V0ZM14.87 12.31C14.9549 11.5429 14.9983 10.7718 15 10C14.9983 9.22822 14.9549 8.4571 14.87 7.69C16.87 8.32 18 9.26 18 10C18 10.74 16.85 11.68 14.87 12.31ZM10 18C9.26 18 8.32 16.85 7.69 14.87C8.4571 14.9549 9.22823 14.9983 10 15C10.7718 14.9983 11.5429 14.9549 12.31 14.87C11.68 16.85 10.74 18 10 18ZM10 13C9.06603 13.0008 8.13334 12.9306 7.21 12.79C6.93003 10.9405 6.93003 9.05946 7.21 7.21C9.05947 6.93002 10.9405 6.93002 12.79 7.21C12.9306 8.13333 13.0008 9.06602 13 10C13.0008 10.934 12.9306 11.8667 12.79 12.79C11.8667 12.9306 10.934 13.0008 10 13V13ZM2 10C2 9.26 3.15 8.32 5.13 7.69C4.95668 9.22512 4.95668 10.7749 5.13 12.31C3.15 11.68 2 10.74 2 10ZM10 2C10.74 2 11.68 3.15 12.31 5.13C10.7749 4.95668 9.22513 4.95668 7.69 5.13C8.32 3.15 9.26 2 10 2ZM17.15 6.44C16.3044 6.02901 15.4156 5.71372 14.5 5.5C14.2863 4.58443 13.971 3.69559 13.56 2.85C15.1147 3.62513 16.3749 4.88528 17.15 6.44V6.44ZM6.44 2.85C6.02901 3.69559 5.71373 4.58443 5.5 5.5C4.58444 5.71372 3.6956 6.02901 2.85 6.44C3.62514 4.88528 4.88529 3.62513 6.44 2.85V2.85ZM2.85 13.56C3.6956 13.971 4.58444 14.2863 5.5 14.5C5.71373 15.4156 6.02901 16.3044 6.44 17.15C4.88529 16.3749 3.62514 15.1147 2.85 13.56ZM13.56 17.15C13.971 16.3044 14.2863 15.4156 14.5 14.5C15.4156 14.2863 16.3044 13.971 17.15 13.56C16.3749 15.1147 15.1147 16.3749 13.56 17.15Z" fill="white"/>
                            </svg>
                        </div>
                        <div class="list-data">
                            <h2 :class="[currentLanguage == 'AR' ? 'rtlText': '']">{{ $t("newhome.banner1.title4") }}</h2>
                        </div>
                    </li>
            </ul>
        </div>
    </div>

    <div class="services" v-if="$route.params.id == 4 || !$route.params.id">
        <div class="section__inner">
            <div class="service-banner">
                    <div class="service-banner__text">
                        <h2 class="service-banner__title" :class="[currentLanguage == 'AR' ? 'rtlText': '']">{{ $t("newhome.banner2.title") }}</h2>
                        <p class="service-banner__desc" :class="[currentLanguage == 'AR' ? 'rtlText': '']">{{ $t("newhome.banner2.description") }}</p>
                    </div>
                    <div class="service-banner__img">
                        <img src="../assets/images/new/mockup.png" alt=".">
                    </div>
            </div>
        </div>
    </div>

    <div
      class="products"
      v-for="(category, index) in visibleCategories"
      :key="category.order"
    >
      <section class="section--products">
        <!-- if design type A, B, C, D -->
        <CarouselA
          v-if="category.design == 'A'"
          :products="visibleProducts(category)"
          :title="category.fullname"
          :categoryid="category.name"
        />

        <CarouselB
          v-if="category.design == 'B'"
          :products="category.products"
          :title="category.fullname"
          :categoryid="category.name"
        />
        <CarouselC
          v-if="category.design == 'C'"
          :products="category.products"
          :title="category.fullname"
          :categoryid="category.name"
        />
        <CarouselD
          v-if="category.design == 'D'"
          :products="visibleProducts(category)"
          :title="category.fullname"
          :categoryid="category.name"
        />
      </section>
    </div>

    <section class="section--our-categories" v-if="loaded">
      <div class="section__inner">
        <div class="section__box section__box--nobg">
            <div class="our-categories">
            <div class="section__head">
                <h3 class="box-title" :class="[currentLanguage == 'AR' ? 'rtlText': '']">{{ $t("home.ourcategories.title") }}</h3>
            </div>

            <div class="our-categories__body">
                <ul class="our-categories__list">
                <li v-for="category in filteredOurCategories" :key="category.id">
                    <router-link :to="{
                        name: 'ProductCategory',
                        params: {
                        type: ($route.params.id || '1'),
                        title: category.item,
                        id: category.id
                        },
                    }">
                        <div class="categories_link__item">
                            <div class="item-image">
                                <img src="../assets/images/new/sample.png" alt=".">
                            </div>
                            <span>{{ category.item }}</span>
                        </div>
                    </router-link>
                </li>
                </ul>
            </div>
            </div>
        </div>
      </div>
    </section>

    <div class="footer-banner" v-if="$route.params.id == 4 || !$route.params.id">
        <div class="section__inner">
                <img class="footer-banner__img alignLeft" src="../assets/images/new/phone-left.png" alt=".">
                <div class="footer-banner__text">
                    <h2 class="footer-banner__title" :class="[currentLanguage == 'AR' ? 'rtlText': '']">{{ $t("newhome.banner3.title") }}</h2>
                    <p class="footer-banner__desc" :class="[currentLanguage == 'AR' ? 'rtlText': '']">{{ $t("newhome.banner3.description") }}</p>

                    <div class="footer-banner__row">
                        <div class="col-icons">
                            <div class="icon-item">
                                <svg width="37" height="25" viewBox="0 0 37 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M30.6006 21.666C32.2581 21.666 33.5856 20.3235 33.5856 18.666L33.6006 3.66602C33.6006 2.00852 32.2581 0.666016 30.6006 0.666016H6.60059C4.94309 0.666016 3.60059 2.00852 3.60059 3.66602V18.666C3.60059 20.3235 4.94309 21.666 6.60059 21.666H0.600586V24.666H36.6006V21.666H30.6006ZM6.60059 3.66602H30.6006V18.666H6.60059V3.66602Z" fill="#ffffff"/>
                            </svg>
                            </div>
                            <div class="icon-item">
                                <svg width="25" height="33" viewBox="0 0 25 33" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M20.6006 0.666016H4.60059C2.39392 0.666016 0.600586 2.45935 0.600586 4.66602V28.666C0.600586 30.8727 2.39392 32.666 4.60059 32.666H20.6006C22.8073 32.666 24.6006 30.8727 24.6006 28.666V4.66602C24.6006 2.45935 22.8073 0.666016 20.6006 0.666016ZM15.2673 29.9993H9.93392V28.666H15.2673V29.9993ZM22.2673 25.9993H2.93392V4.66602H22.2673V25.9993Z" fill="#ffffff"/>
                                </svg>
                            </div>
                            <div class="icon-item">
                                <svg width="19" height="33" viewBox="0 0 19 33" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M16.6006 32.666C17.131 32.666 17.6397 32.4553 18.0148 32.0802C18.3899 31.7052 18.6006 31.1964 18.6006 30.666V2.66602C18.6006 2.13558 18.3899 1.62687 18.0148 1.2518C17.6397 0.876729 17.131 0.666016 16.6006 0.666016H2.60059C2.07015 0.666016 1.56145 0.876729 1.18637 1.2518C0.8113 1.62687 0.600586 2.13558 0.600586 2.66602V30.666C0.600586 31.1964 0.8113 31.7052 1.18637 32.0802C1.56145 32.4553 2.07015 32.666 2.60059 32.666H16.6006ZM8.60059 29.542C8.5961 29.3917 8.62184 29.2419 8.67628 29.1017C8.73073 28.9615 8.81276 28.8336 8.91753 28.7256C9.0223 28.6177 9.14767 28.5319 9.28622 28.4733C9.42476 28.4147 9.57366 28.3845 9.72409 28.3845C9.87451 28.3845 10.0234 28.4147 10.162 28.4733C10.3005 28.5319 10.4259 28.6177 10.5306 28.7256C10.6354 28.8336 10.7174 28.9615 10.7719 29.1017C10.8263 29.2419 10.8521 29.3917 10.8476 29.542C10.8389 29.8342 10.7167 30.1115 10.5069 30.315C10.2972 30.5186 10.0164 30.6325 9.72409 30.6325C9.43179 30.6325 9.15099 30.5186 8.94124 30.315C8.73149 30.1115 8.6093 29.8342 8.60059 29.542ZM13.6006 2.66602C13.8658 2.66602 14.1202 2.77137 14.3077 2.95891C14.4952 3.14645 14.6006 3.4008 14.6006 3.66602C14.6006 3.93123 14.4952 4.18559 14.3077 4.37312C14.1202 4.56066 13.8658 4.66602 13.6006 4.66602H11.6006C11.3354 4.66602 11.081 4.56066 10.8935 4.37312C10.7059 4.18559 10.6006 3.93123 10.6006 3.66602C10.6006 3.4008 10.7059 3.14645 10.8935 2.95891C11.081 2.77137 11.3354 2.66602 11.6006 2.66602H13.6006ZM8.60059 3.66602C8.60059 3.93123 8.49523 4.18559 8.30769 4.37312C8.12016 4.56066 7.8658 4.66602 7.60059 4.66602C7.33537 4.66602 7.08102 4.56066 6.89348 4.37312C6.70594 4.18559 6.60059 3.93123 6.60059 3.66602C6.60059 3.4008 6.70594 3.14645 6.89348 2.95891C7.08102 2.77137 7.33537 2.66602 7.60059 2.66602C7.8658 2.66602 8.12016 2.77137 8.30769 2.95891C8.49523 3.14645 8.60059 3.4008 8.60059 3.66602ZM2.60059 6.66602H16.6006V26.666H2.60059V6.66602Z" fill="#ffffff"/>
                                    </svg>
                            </div>

                            <div class="icon-item">
                                <svg width="23" height="28" viewBox="0 0 23 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M15.5205 4.5861C16.0245 4.00514 16.4089 3.33032 16.6514 2.60041C16.894 1.8705 16.9899 1.09987 16.9338 0.332764C15.3863 0.45768 13.9498 1.18551 12.9338 2.35943C12.4473 2.92206 12.0786 3.5766 11.8495 4.28429C11.6205 4.99198 11.5358 5.73842 11.6005 6.47943C12.3553 6.48572 13.1015 6.31822 13.7813 5.98991C14.461 5.66159 15.0561 5.18126 15.5205 4.5861V4.5861ZM18.8805 14.5061C18.8894 13.4844 19.1585 12.4819 19.6624 11.593C20.1663 10.7042 20.8884 9.95844 21.7605 9.4261C21.2101 8.63308 20.4825 7.97921 19.6355 7.51633C18.7884 7.05345 17.8451 6.7943 16.8805 6.75943C14.8005 6.5461 12.8805 7.97276 11.7738 7.97276C10.6671 7.97276 9.10714 6.7861 7.3738 6.81276C6.24064 6.85009 5.1365 7.18047 4.16906 7.77168C3.20163 8.36289 2.40394 9.19474 1.8538 10.1861C-0.492865 14.2661 1.2538 20.3328 3.60047 23.6261C4.66713 25.2394 6.00047 27.0661 7.76047 26.9994C9.52047 26.9328 10.0938 25.9061 12.1338 25.9061C14.1738 25.9061 14.8005 26.9994 16.5338 26.9594C18.2671 26.9194 19.4938 25.3061 20.6138 23.6928C21.4072 22.5215 22.0269 21.2415 22.4538 19.8928C21.3971 19.4421 20.4956 18.6918 19.8605 17.7345C19.2255 16.7772 18.8848 15.6549 18.8805 14.5061V14.5061Z" fill="#ffffff"/>
                                </svg>
                            </div>
                            <div class="icon-item">
                                <svg width="25" height="30" viewBox="0 0 25 30" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M16.5678 2.69123L17.8475 0.382446C17.864 0.352826 17.8744 0.320262 17.8782 0.286613C17.882 0.252963 17.8792 0.218888 17.8699 0.186333C17.8606 0.153777 17.8449 0.123379 17.8238 0.0968729C17.8027 0.0703672 17.7766 0.0482734 17.747 0.0318529C17.6872 -0.00130974 17.6167 -0.00935062 17.5509 0.00949929C17.4852 0.0283492 17.4296 0.0725458 17.3964 0.132366L16.1025 2.46674C14.9985 1.98275 13.8061 1.73287 12.6007 1.73287C11.3952 1.73287 10.2028 1.98275 9.09883 2.46674L7.80485 0.132366C7.77169 0.0725458 7.71612 0.0283492 7.65037 0.00949929C7.58462 -0.00935061 7.51408 -0.00130973 7.45426 0.0318529C7.39444 0.0650156 7.35024 0.120584 7.33139 0.186333C7.31254 0.252082 7.32058 0.322626 7.35375 0.382446L8.63355 2.69125C7.41532 3.29174 6.386 4.21614 5.65849 5.36305C4.93099 6.50996 4.5334 7.83507 4.50933 9.19305H20.692C20.6679 7.83507 20.2703 6.50995 19.5428 5.36304C18.8153 4.21613 17.786 3.29173 16.5678 2.69123ZM8.86612 6.23203C8.73247 6.23203 8.60183 6.1924 8.4907 6.11815C8.37958 6.0439 8.29297 5.93836 8.24182 5.81489C8.19068 5.69142 8.1773 5.55555 8.20337 5.42447C8.22944 5.29339 8.2938 5.17299 8.3883 5.07848C8.48281 4.98398 8.60321 4.91962 8.73429 4.89355C8.86537 4.86748 9.00124 4.88086 9.12471 4.932C9.24819 4.98315 9.35372 5.06976 9.42797 5.18088C9.50222 5.29201 9.54185 5.42265 9.54185 5.5563C9.54165 5.73545 9.47039 5.90721 9.34371 6.03389C9.21703 6.16057 9.04527 6.23183 8.86612 6.23203ZM16.3352 6.23203C16.2015 6.23203 16.0709 6.1924 15.9597 6.11815C15.8486 6.0439 15.762 5.93836 15.7109 5.81489C15.6597 5.69142 15.6463 5.55555 15.6724 5.42447C15.6985 5.29339 15.7628 5.17299 15.8573 5.07848C15.9518 4.98398 16.0722 4.91962 16.2033 4.89355C16.3344 4.86748 16.4703 4.88086 16.5938 4.932C16.7172 4.98315 16.8228 5.06976 16.897 5.18088C16.9713 5.29201 17.0109 5.42265 17.0109 5.5563C17.0107 5.73545 16.9394 5.90721 16.8128 6.03389C16.6861 6.16057 16.5143 6.23183 16.3352 6.23203ZM4.50921 21.5614C4.50921 22.0802 4.71531 22.5777 5.08216 22.9446C5.44902 23.3114 5.94658 23.5175 6.46539 23.5175H7.76352V27.5188C7.76287 27.7574 7.80931 27.9938 7.90018 28.2145C7.99105 28.4351 8.12456 28.6357 8.29307 28.8046C8.46157 28.9736 8.66176 29.1077 8.88216 29.1991C9.10255 29.2906 9.33883 29.3377 9.57746 29.3377C9.81608 29.3377 10.0524 29.2906 10.2728 29.1991C10.4932 29.1077 10.6933 28.9736 10.8618 28.8046C11.0304 28.6357 11.1639 28.4351 11.2547 28.2145C11.3456 27.9938 11.392 27.7574 11.3914 27.5188V23.5175H13.8099V27.5188C13.8092 27.7574 13.8557 27.9938 13.9465 28.2145C14.0374 28.4351 14.1709 28.6357 14.3394 28.8046C14.5079 28.9736 14.7081 29.1077 14.9285 29.1991C15.1489 29.2906 15.3852 29.3377 15.6238 29.3377C15.8624 29.3377 16.0987 29.2906 16.3191 29.1991C16.5395 29.1077 16.7397 28.9736 16.9082 28.8046C17.0767 28.6357 17.2102 28.4351 17.3011 28.2145C17.392 27.9938 17.4384 27.7574 17.4378 27.5188V23.5175H18.7359C19.2548 23.5175 19.7523 23.3114 20.1192 22.9446C20.486 22.5777 20.6921 22.0802 20.6921 21.5614V9.83318H4.50921V21.5614ZM2.01951 9.52197C1.53859 9.52251 1.07752 9.7138 0.737461 10.0539C0.397401 10.3939 0.206117 10.855 0.205573 11.3359V18.8939C0.204926 19.1325 0.251368 19.3689 0.342237 19.5895C0.433106 19.8102 0.566617 20.0107 0.735121 20.1797C0.903626 20.3487 1.10381 20.4827 1.32421 20.5742C1.54461 20.6656 1.78089 20.7127 2.01951 20.7127C2.25814 20.7127 2.49442 20.6656 2.71482 20.5742C2.93521 20.4827 3.1354 20.3487 3.3039 20.1797C3.47241 20.0107 3.60592 19.8102 3.69679 19.5895C3.78766 19.3689 3.8341 19.1325 3.83345 18.8939V11.3359C3.83291 10.855 3.64162 10.3939 3.30156 10.0539C2.9615 9.7138 2.50043 9.52251 2.01951 9.52197ZM23.1818 9.52197C22.7008 9.52251 22.2398 9.7138 21.8997 10.0539C21.5597 10.3939 21.3684 10.855 21.3678 11.3359V18.8939C21.3672 19.1325 21.4136 19.3689 21.5045 19.5895C21.5954 19.8102 21.7289 20.0107 21.8974 20.1797C22.0659 20.3487 22.2661 20.4827 22.4865 20.5742C22.7069 20.6656 22.9431 20.7127 23.1818 20.7127C23.4204 20.7127 23.6567 20.6656 23.8771 20.5742C24.0975 20.4827 24.2977 20.3487 24.4662 20.1797C24.6347 20.0107 24.7682 19.8102 24.859 19.5895C24.9499 19.3689 24.9964 19.1325 24.9957 18.8939V11.3359C24.9952 10.855 24.8039 10.3939 24.4638 10.0539C24.1238 9.7138 23.6627 9.52251 23.1818 9.52197Z" fill="#ffffff"/>
                                </svg>
                            </div>
                            <div class="icon-item">
                                <svg width="27" height="27" viewBox="0 0 27 27" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M26.934 0.332764L12.534 2.4661V13.1328L26.934 12.9994V0.332764ZM11.2007 14.3328L0.267334 14.1994V23.2661L11.0673 24.7328L11.2007 14.3328ZM0.267334 4.0661V13.1328H11.0673V2.59943L0.267334 4.0661ZM12.4007 14.3328V24.8661L26.934 26.9994V14.4661L12.4007 14.3328Z" fill="#ffffff"/>
                                </svg>
                            </div>
                        </div>
                        <div class="col-image">
                            <a :href="landingPage">
                              <button class="footer-banner__cta" :class="[currentLanguage == 'AR' ? 'rtlText': '']" v-if="!isLoggedIn">{{ $t("newhome.banner3.button") }}</button>
                            </a>
                        </div>
                    </div>
                </div>
                <img class="footer-banner__img alignRight" src="../assets/images/new/phone-right.png" alt=".">
        </div>
    </div>

    <cookie-law theme="portal" :buttonText="$t('cookie.btn')">
      <template #message>
        <div :class="[currentLanguage == 'AR' ? 'rtlText': '']">
            {{ $t("cookie.message") }}
            <router-link to="cookies-policy" :class="[currentLanguage == 'AR' ? 'rtlText': '']">
                {{ $t("cookie.link") }}
            </router-link>
        </div>
      </template>
    </cookie-law>
  </div>
</template>

<script>
import CookieLaw from '../components/CookieLaw.vue';
import { mapGetters, mapActions } from 'vuex';
import axios from 'axios';
import { helpers } from '../helper/portal_config';
import EventBus from '../helper/event_bus';

import CarouselA from '../components/CarouselA';
import CarouselB from '../components/CarouselB';
import CarouselC from '../components/CarouselC';
import CarouselD from '../components/CarouselD';

// api to get products
const apiPrTypeMethod = 'getProductListByType';

export default {
  name: 'Home',
  title: helpers.portal_name,
  data() {
    return {
      helpers: '',
      categories: [],
      allCategories: [],
      hasBannerFlag: null,
      currentLanguage: "",
      currentCountry: "",
      options: { quality: { default: '1080p' } },
      loaded: false,
    };
  },
  components: {
    CarouselA,
    CarouselB,
    CarouselC,
    CarouselD,
    CookieLaw
  },
  methods: {
    checkIsLogged() {
      // if you are not login than showed modal
      if (!this.isLoggedIn) {
        EventBus.$emit('SHOW_SIGNIN_MODAL');
      }
    },
    setProducts(types) {
      const keys = Object.keys(types);
      keys.forEach((element, index) => {
        types[element].fullname = element;
        this.allCategories.push(types[element]);
      });
      // filtered only homepage
      const categoriesFiltered = this.allCategories.filter((item) => item.homepage > 0);
      // sorting homepage categories
      this.sortProducts(categoriesFiltered);
    },
    sortProducts(filteredProducts) {
      filteredProducts.sort((a, b) => a.homepage - b.homepage);
      filteredProducts = this.slicesProducts(filteredProducts);
      this.allCategories = filteredProducts;
    },
    slicesProducts(products) {
      return products.map((item) => {
        item.products = item.products.slice(0, item.max_products);
        return item;
      });
    },
    sortCategories(categoriesLocal) {
        const ordered = (categoriesLocal || []).filter(
        (c) => c && c.order != null
      )
      categoriesLocal.sort((a, b) => a.order - b.order);
      this.categories = categoriesLocal;
    },
    hasBanner() {
        let banner = document.querySelector('.page-header__menu li.is-active a');
        let type = banner.getAttribute('href').substr(banner.getAttribute('href').length-1, banner.getAttribute('href').length);
        console.log( type);
        return helpers.menu.some(function(item) {
            return (item.type == type && item.isActive == true && item.banner == 1);
        });
    },
    setCurrentCountry() {
      const { host } = window.location;
      this.currentCountry = host.split('.')[0].slice(0,2).toUpperCase();
    },
    setCurrentLanguage() {
      var lang = "";
      const { host } = window.location;
      var country = host.split('.')[0].slice(0,2).toUpperCase();
      if (helpers.countryDefaultLanguage.hasOwnProperty(country)) {
        lang = helpers.countryDefaultLanguage[country].toUpperCase();
      } else {
        lang = country.toUpperCase();
      }
      this.currentLanguage = lang;
    },
      async fetchCategories() {
      // check user was logged and send access_code as a parameter.
      this.loaded = false;
      let apiUrl = null;
      if (this.isLoggedIn) {
        apiUrl = `https://api.hubdelivery.io/store/${apiPrTypeMethod}?portal_name=${helpers.portal_name
        }&country=${this.currentCountry}&language=${this.currentLanguage}&product_type=${this.$route.params.id || helpers.portal_type
        }&access_code=${this.accessCode}`;
      } else {
        apiUrl = `https://api.hubdelivery.io/store/${apiPrTypeMethod}?portal_name=${helpers.portal_name
        }&country=${this.currentCountry}&language=${this.currentLanguage}&product_type=${this.$route.params.id || helpers.portal_type
        }`;
      }

      await axios
        .get(
            apiUrl
        )
        .then((response) => {
          if (response.data.treatment === 1) {
            const { categories } = response.data;
            const types = categories;
            this.setProducts(types);

            // upload categories
            const categoriesKeys = Object.keys(categories);
            const categoriesLocal = [];
            categoriesKeys.forEach((element, index) => {
              const obj = {
                id: types[element].name,
                item: element,
                order: types[element].order,
              };
              categoriesLocal.push(obj);
            });
            this.sortCategories(categoriesLocal);
            this.loaded=true;
          }
        });
    },
    visibleProducts(category) {
          if (this.currentCountry === 'AE' && this.helpers.portal_name === 'Runsio') {
          return category.products.filter(p => ![2, 6].includes(p.type));
      }
      return category.products;
    }
  },
  computed: {
    ...mapGetters({
      accessCode: 'globals/accessCode',
      isLoggedIn: 'globals/isLoggedIn',
    }),
    landingPage: function() {
        this.setCurrentCountry();
        let country = this.currentCountry;
        return helpers.landingUrl[0][country];
    },
    visibleCategories() {
      if (this.currentCountry === 'AE' && this.helpers.portal_name === 'Runsio') {
          const hidden = [
              'Most Popular Apps',
              'Most Downloaded Apps',
              'Best Action Apps',
              'Popular Sports Apps'
          ];
          return this.allCategories.filter(cat => !hidden.includes(cat.fullname));
      }
      return this.allCategories;
    },
    filteredOurCategories() {
      if (this.currentCountry === 'AE' && this.helpers.portal_name === 'Runsio') {
        const hidden = [
          'Most Downloaded Apps',
          'Most Popular Apps',
          'Best Action Apps',
          'Popular Sports Apps'
        ];
        return this.categories.filter(cat => !hidden.includes(cat.item));
      }
      return this.categories;
    }
  },
  watch: {
    $route(to, from) {
      this.allCategories = [];
      this.categories = [];
        this.fetchCategories();
    },
  },
  created() {
    this.helpers = helpers;

    this.setCurrentLanguage();
    this.setCurrentCountry();
    this.fetchCategories();
  },
  mounted() {
    this.hasBannerFlag = this.hasBanner();
  },
};
</script>

<style>
.Cookie--portal {
    background: #000;
    padding: 8px 25px;
    box-shadow: 0 -10px 25px rgba(0, 0, 0, 0.1);
}

.Cookie--portal {
    color: #fff;
    font-size: 14px;
}

.Cookie--portal a {
    color: #fff;
    font-size: 14px;
    text-decoration: underline;
}

.Cookie--portal a:hover {
    color: #F6212B;
}

.Cookie--portal .Cookie__button {
  background: #222;
  color: #F6212B;
  border-radius: 5px;
  padding: 10px 35px;
}

.Cookie--portal .Cookie__button:hover {
  background: #F6212B;
  color: #222;
}

@media (max-width: 800px) {
    .Cookie--portal .Cookie__button {
        margin-bottom: 0;
    }

    .Cookie--portal .Cookie__content {
        margin: 0;
    }

    .Cookie--portal .Cookie__button {
        font-size: 12px;
    }

    .Cookie--portal .Cookie__buttons {
        margin-top: 5px;
    }
}
</style>
